import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import PlaceAnOrder from '../../components/PlaceAnOrder';
import FreeShipping from '../../components/FreeShipping';
import DiscountByType from '../../components/DiscountByType';

const WaysToEarn = () => {
  let [searchParams, setSearchParams] = useSearchParams();
  const [rewardsType, setRewardsType] = useState<string>('1');
  const [rewardId, setRewardId] = useState<string>('');
  const possibleOptions = ['1', '2', '3'];

  const getParamValues = () => {
    const reward = searchParams.get('type');
    const id = searchParams.get('id');

    if (reward) {
      setRewardsType(reward);
      if (!possibleOptions.includes(reward)) {
        navigate('/program');
      }
    } else {
      navigate(-1);
    }

    if (id) {
      setRewardId(id);
    } else {
      setRewardId('');
    }
  };

  const navigate = useNavigate();
  useEffect(() => {
    getParamValues();
  }, []);

  return (
    <div>
      {rewardsType === '3' && (
        <FreeShipping rewardId={rewardId} rewardTypeId={rewardsType} />
      )}
      {rewardsType === '1' && (
        <DiscountByType
          discountType='amount'
          rewardId={rewardId}
          rewardTypeId={rewardsType}
        />
      )}
      {rewardsType === '2' && (
        <DiscountByType
          discountType='percentage'
          rewardId={rewardId}
          rewardTypeId={rewardsType}
        />
      )}
    </div>
  );
};

export default WaysToEarn;
